module.exports = __webpack_public_path__ + "img/chevron-right.80644790.svg";